import ProfileEntity from '@/entities/Profile'
import ProfileRepository from '@/repositories/ProfileRepository'
import FaceEntity from '@/entities/Face'
import ChildEntity from '@/entities/Child'
import EventRepository from '@/repositories/EventRepository'
import GroupRepository from '@/repositories/GroupRepository'
import { UchinokoEventPhotos } from '@/types/domain/uchinoko'

export interface IPresenterParams {
  profileRepository: ProfileRepository
  eventRepository: EventRepository
  groupRepository: GroupRepository
  eventId: number
}

export interface IPresenter {
  profile: ProfileEntity | null
  uchinokoFaces: FaceEntity[]
  hasNoSearchResult: boolean
  selectedUchinokoFaces: {
    [faceId: string]: boolean
  }
  faceEventPhotos: UchinokoEventPhotos
  uchinokoPhotosByAlbumsCount: number
  hasThumbnail: boolean
}

export default ({ profileRepository, eventRepository, groupRepository, eventId }: IPresenterParams): IPresenter => {
  const profile = profileRepository.getProfile()
  const selectedUchinokoFaces = eventRepository.getSelectedUchinokoFaces(eventId)
  const selectedUchinokoFacesCount = Object.keys(selectedUchinokoFaces).filter(faceId => selectedUchinokoFaces[faceId]).length
  const uchinokoPhotosByAlbumsCount = eventRepository.getUchinokoEventPhotosByAlbumsCount(eventId)

  let childrenList: ChildEntity[] = []
  const children = groupRepository.getChildrenByEvent(eventId)
  childrenList = Object.values(children)
    .reduce((acc, ac) => [...acc, ...ac], [] as ChildEntity[])
    .filter(child => child.props.profileImage)
  const hasThumbnail = childrenList.some((child: ChildEntity) => {
    return child.props.profileImage
  })

  return {
    profile,
    uchinokoFaces: eventRepository.getUchiokoFaces(eventId),
    hasNoSearchResult: eventRepository.getUchinokoEventPhotosByAlbumsCount(eventId) === 0 && selectedUchinokoFacesCount === Object.keys(selectedUchinokoFaces).length,
    selectedUchinokoFaces,
    faceEventPhotos: eventRepository.getUchinokoEventPhotos(eventId),
    uchinokoPhotosByAlbumsCount,
    hasThumbnail
  }
}
